import { reputation } from "@/mocks/chigua";

const principles = [
  { icon: 'ri-compass-3-line', title: '导航而非生产', desc: '我们不做瓜的"编剧"，只做瓜田的"地图"。把分散在全网的板块与事件整理清楚，还你一个干净的围观入口。' },
  { icon: 'ri-focus-2-line', title: '追踪而非断章', desc: '热点瞬息万变，吃瓜入口索引关注事件的完整脉络，帮你看到前情、经过与后续，避免只见片段就下判断。' },
  { icon: 'ri-eye-line', title: '开放而非站队', desc: '我们保持中立立场，不预设结论、不替用户站队，只把多方面的公开信息与讨论入口摆到你面前，由你自行判断。' },
  { icon: 'ri-leaf-line', title: '清爽而非刷屏', desc: '拒绝标题党与无效信息轰炸，吃瓜入口大全追求"少而准"，让每一个入口都真正有用、可直达。' },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
              <i className="ri-water-flash-line" aria-hidden="true"></i>
              关于吃瓜
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">把全网瓜田，收进一张地图</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              作为一个中立、透明的瓜田导航入口，吃瓜入口网的核心工作只有一件事——做好"引路"。
              我们把微博、知乎、抖音等平台的官方热榜，以及散落在各处的热门讨论入口，统一收编成吃瓜入口地图与吃瓜入口索引，让大家告别来回切换的麻烦。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们的内容原则是<strong className="font-semibold text-foreground-900">尊重事实、来源可溯、不替结论</strong>。每条索引都指向可公开查看的原始讨论，让"吃瓜"这件事变得更清爽、更理性、也更轻松。
            </p>

            <div className="mt-7 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {reputation.map((r) => (
                <div key={r.stat} className="rounded-xl border border-background-200/70 bg-background-100/60 p-4 text-center">
                  <i className={`${r.icon} text-2xl text-primary-500`} aria-hidden="true"></i>
                  <p className="mt-2 font-heading text-xl leading-none text-foreground-950">{r.value}</p>
                  <p className="mt-1 whitespace-nowrap text-xs text-foreground-500">{r.stat}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.title} className="rounded-xl border border-background-200/70 bg-background-100/50 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                  <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 text-base font-semibold text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}